import { React, useState, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from "react-redux";
import AutosuggestComponent from './AutosuggestComponent';

import { encoded } from '../../../utils/cryptoUtils';

import { GetAutoSuggestions, GetItemStockData } from '../../../redux/actions/Admin'; // Redux action

const ItemAutosuggest = ({
    style,
    input_style,
    label,
    type,
    placeholder,
    name,
    value,
    onChange,
    required,
    hidden,
    disabled,
    display,
    setFormData
}) => {
    const dispatch = useDispatch();
    const itemDataRedux = useSelector((state) => state.admin.itemData);
    const autoSuggestionList = useSelector((state) => state.admin.autoSuggestionList || []);
    const [suggestions1, setSuggestions1] = useState([]);

    const fetchItemStockData = (item_id) => {
        if (item_id) {
            dispatch(GetItemStockData(encoded(JSON.stringify({ item_id }))));
        }
    };

    useEffect(() => {
        if (itemDataRedux) {
            setFormData(prev => ({
                ...prev,
                item: itemDataRedux,
            }));
        }
    }, [itemDataRedux, setFormData]);

    const escapeRegexCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const getSuggestions1 = (value) => {
        if (!value || typeof value !== "string") {
            return [];
        }

        setFormData((prev) => ({
            ...prev,
            item: {}, // Clears item when input is empty
        }));

        setFormData((prev) => ({
            ...prev,
            item: {
                ...prev.item,
                item_name: value,
            },
        }));
        return autoSuggestionList.filter((user) => {
            const itemObject = user.customObject || {}; // Ensure object exists

            const itemData = `${itemObject.item_name?.toUpperCase() || ""} 
                              ${itemObject.item_short_name?.toUpperCase() || ""} 
                              ${itemObject.item_regional_name?.toUpperCase() || ""} 
                              ${itemObject.hsn_code?.toUpperCase() || ""}`.trim();

            const textData = escapeRegexCharacters(value.trim().toUpperCase());

            return itemData.includes(textData);
        });
    };

    const getSuggestionValue1 = (suggestion) => suggestion?.customObject?.item_name || "";

    const onChange1 = (event, { newValue }) => {
        console.log(newValue)
        if (newValue == null) return;
        setFormData((prev) => ({
            ...prev,
            item: {
                ...prev.item,
                item_name: newValue,
            },
        }));
    };

    const onSuggestionsFetchRequested1 = ({ value, reason }) => {
        if (!value || typeof value !== "string") return;
        if (reason === "input-changed") {
            let newData = getSuggestions1(value);
            if (newData?.length === 0 && value.length > 1) {
                dispatch(GetAutoSuggestions(
                    encoded(
                        JSON.stringify({
                            branch_id: localStorage.getItem("branch_id_1"),
                            object_type: "Item",
                            type_of_entity: "S|I|R|C",
                            search_value: value,
                        })
                    )
                )); // Redux call
            }
            setSuggestions1(newData);
        }
    };

    useEffect(() => {
        if (autoSuggestionList.length !== suggestions1.length) {
            setSuggestions1(autoSuggestionList);
        }
    }, [autoSuggestionList]);

    const onSuggestionsClearRequested1 = () => {
        setSuggestions1([]);
    };

    const onSuggestionSelected1 = (event, { suggestion }) => {
        event.preventDefault();

        if (!suggestion || !suggestion.customObject) {
            return;
        }

        const selectedItem = suggestion.customObject;
        console.log("Selected Item:", selectedItem);
        if (selectedItem.type_of_item === "S") {
            setFormData((prev) => ({
                ...prev,
                item: {
                    ...selectedItem,
                },
            }));
        } else {
            fetchItemStockData(selectedItem?.item_id);
        }
    };

    const onBlur1 = (event, { highlightedSuggestion }) => {
        if (!highlightedSuggestion || !highlightedSuggestion.customObject) {
            return;
        }

        const selectedItem = highlightedSuggestion.customObject;
        console.log("Highlighted Item:", selectedItem);

        if (selectedItem.type_of_item === "S") {
            setFormData((prev) => ({
                ...prev,
                item: {
                    ...selectedItem,
                },
            }));
        } else {
            fetchItemStockData(selectedItem?.item_id);
        }
    };


    return (
        <AutosuggestComponent
            style={style}
            input_style={input_style}
            label={label}
            type={type}
            placeholder="Items..."
            required={required}
            name={name}
            value={value}
            hidden={hidden}
            disabled={disabled}
            display={display}
            suggestions={suggestions1}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested1}
            onSuggestionSelected={onSuggestionSelected1}
            onSuggestionsClearRequested={onSuggestionsClearRequested1}
            getSuggestionValue={getSuggestionValue1}
            onChange={onChange1}
            onBlur={onBlur1}
        />
    );
};

ItemAutosuggest.propTypes = {
    style: PropTypes.string,
    input_style: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    display: PropTypes.bool,
    setFormData: PropTypes.func,
}

export default ItemAutosuggest;
